export default {
  english: {
    topVideos: 'Top videos',
    next: 'Next',
    previous: 'Previous',
  },
  french: {
    topVideos: 'Top videos',
    next: 'Suivant',
    previous: 'Précédent',
  },
  arabic: {
    topVideos: 'أفضل الفيديوهات',
    next: 'التالي',
    previous: 'السابق',
  },
  hebrew: {
    topVideos: 'הנצפים ביותר',
    next: 'הבא',
    previous: 'הקודם',
  },
  persian: {
    topVideos: 'ویدیوهای برتر',
    next: 'بعدی',
    previous: 'قبلی',
  },
}
